import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class InfrastructureTypesApi extends ApiModule {
	constructor() {
		super(ModulesMap.INFRASTRUCTURE_TYPES, {
			entity: 'infrastructure_types',
		})
	}
}
